import React from "react";
import Labels from "../labels/Labels";

import UserService from "../services/UserService";
import { getIdpHint } from "../util/idp";
import { AppBar, Box, Button, Grid, Toolbar, Typography, Stack, Paper } from "@mui/material";
import Footer from "../components/Footer";

export default function Welcome() {
  // Get IdP config once and use throughout
  const idpConfig = getIdpHint();
  const [RellevateLogo, setSmallLogo] = React.useState(null);
  const [smileImg, setLogo] = React.useState(null);
  const [backgroundImg, setBackgroundImg] = React.useState(null);

  async function getInitials(subdomain) {
    try {
      const extension = subdomain ? `.${subdomain}` : "";
      const [smallLogo, logo, backgroundImg] = await Promise.all([
        import(`../company-logo${extension}.svg`),
        import(`../images/Man-smiling-transparent-background-e1687753105269${extension}.webp`),
        import(`../images/Orange-to-green-background${extension}.png`),
      ]);
      setSmallLogo(smallLogo.default);
      setLogo(logo.default);
      setBackgroundImg(backgroundImg.default);
    } catch (error) {
      console.error(error);
      getInitials("");
    }
  }

  React.useEffect(() => {
    getInitials(window.subdomain);
  }, []);

  return (
    <Box>
      <AppBar
        position="sticky"
        sx={{ bgcolor: "white", boxShadow: "0 10px 8px 0 rgba(0,0,0,.15)" }}
      >
        <Toolbar>
          <Box component="div" sx={{ flexGrow: 1 }}>
            <img
              src={RellevateLogo}
              alt="upload"
              width="100%"
              loading="lazy"
              style={{
                marginLeft: 0,
                marginTop: 20,
                marginBottom: 20,
                maxWidth: "260px",
              }}
            />
          </Box>
          {/* SSO Button in header only for single IdP */}
          {(!Array.isArray(idpConfig)) ? (
            <Button
              color="primary"
              variant="contained"
              sx={{ fontSize: "15px" }}
              onClick={() => UserService.doLogin()}
            >
              SIGN IN
            </Button>
          ) : null}
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          padding: 0,
          margin: 0,
          backgroundImage: backgroundImg ? `url(${backgroundImg})` : 'none',
          minHeight: "90vh",
          width: "100%",
          backgroundColor: "#100F9200",
          backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: "80%" }}>
          <Grid container spacing={2}>
            <Grid item xs={7}>
              <Typography variant="h3" sx={{ fontWeight: "600" }} pt={20}>
                {Labels.getLabel("welcomePage.Title", "Employer Portal")}
              </Typography>
              <Typography variant="body1" pt={1} fontSize={20}>
                {Labels.getLabel(
                  "welcomePage.Subtitle",
                  "At the forefront of Accessing, Using, and Moving money anytime, anywhere."
                )}
              </Typography>
              <Box ml={3} mt={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold" }}
                      fontSize={20}
                    >
                      {Labels.getLabel("welcomePage.TitleColumn.1","Digital Funds Management")}
                    </Typography>
                    <Typography variant="body2" fontSize={16}>
                      <ul>
                        {Labels.getLabel("welcomePage.Column.1.1","Balance Control") && (
                          <li>{Labels.getLabel("welcomePage.Column.1.1","Balance Control")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.1.2","Instant Payments") && (
                          <li>{Labels.getLabel("welcomePage.Column.1.2","Instant Payments")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.1.3","Team grouping") && (
                          <li>{Labels.getLabel("welcomePage.Column.1.3","Team grouping")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.1.4","Custom payment labeling") && (
                          <li>{Labels.getLabel("welcomePage.Column.1.4","Custom payment labeling")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.1.5","Payment alerts") && (
                          <li>{Labels.getLabel("welcomePage.Column.1.5","Payment alerts")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.1.6","Analytics") && (
                          <li>{Labels.getLabel("welcomePage.Column.1.6","Analytics")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.1.7","Real time insights") && (
                          <li>{Labels.getLabel("welcomePage.Column.1.7","Real time insights")}</li>
                        )}
                      </ul>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold" }}
                      fontSize={20}
                    >
                      {Labels.getLabel("welcomePage.TitleColumn.2","Card Management")}
                    </Typography>
                    <Typography variant="body2" fontSize={16}>
                      <ul>
                        {Labels.getLabel("welcomePage.Column.2.1","Card Ordering") && (
                          <li>{Labels.getLabel("welcomePage.Column.2.1","Card Ordering")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.2.2","Multiple Locations") && (
                          <li>{Labels.getLabel("welcomePage.Column.2.2","Multiple Locations")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.2.3","Standard or Personalized Embossing") && (
                          <li>{Labels.getLabel("welcomePage.Column.2.3","Standard or Personalized Embossing")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.2.4","Card Handout/Distribution") && (
                          <li>{Labels.getLabel("welcomePage.Column.2.4","Card Handout/Distribution")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.2.5","Adaptive Personal Info Collection") && (
                          <li>{Labels.getLabel("welcomePage.Column.2.5","Adaptive Personal Info Collection")}</li>
                        )}
                        {Labels.getLabel("welcomePage.Column.2.6","Analytics") && (
                          <li>{Labels.getLabel("welcomePage.Column.2.6","Analytics")}</li>
                        )}
                      </ul>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box mt={2}>
                {/* SSO Buttons in body only for multiple IdPs, vertical stack, with logo and description */}
                {Array.isArray(idpConfig) ? (
                  <Stack direction="column" spacing={2}>
                    {idpConfig
                      .sort((a, b) => (a.order || 0) - (b.order || 0))
                      .map((idp) => (
                        <Paper
                          key={idp.idpHint}
                          elevation={4}
                          sx={{
                            borderRadius: 3,
                            overflow: "hidden",
                            mb: 1,
                            transition: "box-shadow 0.3s",
                            boxShadow: 3,
                            backgroundColor: 'primary.main',
                            '&:hover': {
                              boxShadow: 8,
                            },
                          }}
                        >
                          <Button
                            variant="text"
                            sx={{
                              width: "100%",
                              minHeight: 64,
                              p: 0,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: 3,
                              backgroundColor: "transparent",
                              '&:hover': {
                                backgroundColor: "rgba(0,0,0,0.04)",
                              },
                            }}
                            onClick={() => UserService.doLogin(idp.idpHint)}
                          >
                            <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", py: 1 }}>
                              {(() => {
                                try {
                                  return (
                                    <img
                                      src={require(`../images/idps-buttons-img/${idp.idpHint}.svg`)}
                                      alt={idp.name || idp.idpHint}
                                      style={{ width: "90%", maxWidth: 400, height: 48, objectFit: "contain", borderRadius: 8 }}
                                    />
                                  );
                                } catch (e) {
                                  return (
                                    <Typography variant="h6" sx={{ color: '#fff', textAlign: 'center', width: '100%' }}>
                                      {idp.name || idp.idpHint}
                                    </Typography>
                                  );
                                }
                              })()}
                            </Box>
                          </Button>
                        </Paper>
                      ))}
                  </Stack>
                ) : (
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{ fontSize: "15px" }}
                    onClick={() => UserService.doLogin()}
                    pt={2}
                  >
                    SIGN IN
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid item xs={5}>
              <img
                src={smileImg}
                alt="upload"
                width="100%"
                loading="lazy"
                style={{
                  marginLeft: 0,
                  marginTop: 20,
                  marginBottom: 20,
                  maxWidth: "500px",
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}
